// extracted by mini-css-extract-plugin
export var chevron = "_pg-1";
export var clickable = "_pg-0";
export var ruleRow = "_pg-2";